import React, { ChangeEvent, useEffect, useState } from "react";
import {
  collection,
  doc,
  getFirestore,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { NewProjectProfileType } from "../Types/projectProfile";
import { app } from "../lib/firebase";
import styles from "./ProjectSelect.module.css";
import WelcomePage from "../WelcomePage/WelcomePage";
import UserExperiment from "./UserExperiment";

const db = getFirestore(app);

//The goal here is to have the user select the project for which to perform
//an experiment.

//Do a firebase query where userID = currentUserID against the projectExperiments
//collection and place the titles into an array

//User the array to fill the values of a listbox

//The listbox selection will then perform a fetch to firebase to
//retrieve the details of the project and fill out that information on the page

//When the user is satisfied that have the correct project then they click proceed button.

//The click of the proceed button will take the project title selected and place that
//in global storage and then switching to the UserExperiment Page

//The UserExperiment module will in turn use the title value in a query to firebase
//to fetch all the experiments that the user has performed for that project title

//When the compilation of experiments has been gathered then UserExperiment will
//call ExperimentInformation and pass to it the docs via in an IProp interface
const tempUser = localStorage.getItem("userUID")!;
let projectTitlesIndex = 0;
let projectTitles: string[] = [];
let projectDescriptions: string[] = [];
let projectDetailedDescriptions: string[] = [];
let projectHashtags: string[] = [];

function ExperimentProjectSelect() {
  const [projectTitleInput, setProjectTitleInput] = useState("");

  const [projectDescriptionInput, setProjectDescriptionInput] = useState("");
  const [projectDetailedDescriptionInput, setProjectDetailedDescriptionInput] =
    useState("");
  const [projectHashtagsInput, setProjectHashtagsInput] = useState("");

  const [projectProfiles, setProjectProfiles] = useState<
    NewProjectProfileType[]
  >([]);

  const ProceedButtonClicked = () => {
    console.log(" arg is ", projectTitlesIndex);
    console.log(" local storage is ", localStorage.getItem("projectTitle"));
    //UserExperiment();
  };

  const ProjectSelected = (e: ChangeEvent<HTMLSelectElement>) => {
    console.log("project selected entered...");
    const projectTitlesIndex = e.currentTarget.selectedIndex - 1;
    //localStorage.setItem("projectTitle", projectTitles[projectTitlesIndex]);
    console.log(" project selected values is ", e.target.value);
    console.log(" project selected index is ", projectTitlesIndex);
    setProjectTitleInput(projectTitles[projectTitlesIndex]);
    setProjectDescriptionInput(projectDescriptions[projectTitlesIndex]);
    setProjectDetailedDescriptionInput(
      projectDetailedDescriptions[projectTitlesIndex]
    );
    setProjectHashtagsInput(projectHashtags[projectTitlesIndex]);
    localStorage.setItem("projectTitle", projectTitles[projectTitlesIndex]);
    console.log(
      " project selected title is ",
      projectTitles[projectTitlesIndex]
    );
    console.log(
      " project selected title is ",
      projectTitles[projectTitlesIndex]
    );
    console.log(
      " project selected description is ",
      projectDescriptions[projectTitlesIndex]
    );
  };

  let docRefArray: string[] = [];

  const projectTitlesLength = projectTitles.length;
  let tempProject: NewProjectProfileType;

  console.log("user is = ", tempUser);
  const q1 = query(
    collection(db, "projectProfiles"),
    where("title", "!=", ""),
    where("usersUID", "array-contains", tempUser),
    orderBy("title")
  );
  useEffect(
    () =>
      onSnapshot(q1, (snapshot) => {
        setProjectProfiles(
          snapshot.docs.map((doc) => {
            //console.log(" adminInfo 1 doc id = ", doc.id);
            //console.log(" adminInfo 2 projectProfiles = ", projectProfiles);
            tempProject = projectProfiles;

            if (doc.id) {
              //console.log(" ProjectSelect got a doc id from onSnapshot! ");
              docRefArray.push(doc.id);
              //console.log(" docRefArray [0] ", docRefArray[0]);
              console.log(" doc data () ", doc.data());
            }
            return {
              id: doc.id,
              ...doc.data(),
            };
            //return {};
          })
        );
      }),
    []
  );

  //The following produces a single document snapshot
  //getDoc(doc(getFirestore(), "projectProfiles", "projectTitle")).then(
  //  (projectTitle) => {
  //    console.log("adminInfo projectTitle = ", projectTitle);
  //  }
  //);
  //console.log(" before if projectProfiles and tempProject = ", tempProject);
  if (projectProfiles !== undefined) {
    //The array of full objects with id as the key
    //console.log(" adminInfo projectProfiles = ", projectProfiles);
    //What we'd like to do here is to create a new array consisting of just
    //The project titles (projectTitle) and that array will provide for the list box
    console.log(" project profiles length is = ", projectProfiles.length);
    for (let i = 0; i < projectProfiles.length; i++) {
      projectTitles[i] = projectProfiles[i].title;
      projectDescriptions[i] = projectProfiles[i].description;
      projectDetailedDescriptions[i] = projectProfiles[i].detailedDescription;
      projectHashtags[i] = projectProfiles[i].projectHashtags;
      console.log("project titles array [0] = ", projectTitles[0]);
      console.log("project descriptions array [0] = ", projectDescriptions[0]);
    }
  }

  return (
    <>
      <div className={styles.wrapper} />
      <div className={styles.top}>
        <h2 className={styles.header} style={{ marginLeft: 50 }}>
          Experiment Project Selection
        </h2>
        <div> &emsp;</div>
        <label
          className={styles.forh3}
          style={{ marginLeft: 50, fontWeight: 550 }}
        >
          Instructions
        </label>
        <input
          className={styles.messageText}
          style={{ marginLeft: 89, width: 655 }}
          type="text"
          readOnly
          value="Select a project for which to perform the experiment then press the Proceed button or press close to return"
        />
        <div> &emsp;</div>
        <div>
          <label
            className={styles.forh3}
            style={{ marginLeft: 50, fontWeight: 550 }}
          >
            Projects
          </label>
          <select
            name="Project List"
            id="project-select"
            onChange={ProjectSelected}
            style={{ marginLeft: 117 }}
          >
            <option value="">-- Project Selections --</option>
            {projectTitles.map((projectTitles, key) => (
              <option key={key} value={projectTitles}>
                {projectTitles}
              </option>
            ))}
          </select>
        </div>
        <div> &emsp;</div>
        <div className={styles.forh3}>
          <label style={{ marginLeft: 50, fontWeight: 550 }}>
            Project Title
          </label>
          <input
            className={styles.messageText}
            style={{ marginLeft: 88, width: 475 }}
            type="text"
            readOnly
            value={projectTitleInput}
          />
          <br />
        </div>
        <div className={styles.aimLabel}>
          <label style={{ marginLeft: 30, fontWeight: 550 }}>
            Project Description
          </label>
          <textarea
            className={styles.messageText}
            rows={4}
            cols={80}
            style={{ marginLeft: 32, width: 475, height: 60 }}
            readOnly
            value={projectDescriptionInput}
          />
        </div>
        <div className={styles.aimLabel}>
          <label style={{ marginLeft: 30, fontWeight: 550 }}>
            Detailed Description
          </label>
          <textarea
            className={styles.messageText}
            rows={4}
            cols={80}
            style={{ marginLeft: 24, width: 475, height: 90 }}
            readOnly
            value={projectDetailedDescriptionInput}
          />
        </div>
        <div className={styles.aimLabel}>
          <label style={{ marginLeft: 30, fontWeight: 550 }}>
            Project Hashtags
          </label>
          <textarea
            className={styles.messageText}
            rows={4}
            cols={80}
            style={{ marginLeft: 47, width: 475, height: 35 }}
            readOnly
            value={projectHashtagsInput}
          />
        </div>
        <br></br>
        <br></br>
        <div>
          <a href="UserExperiment">
            <button
              id="proceedButtonID"
              className={styles.proceedButtonClass}
              style={{ marginLeft: 450 }}
            >
              Proceed
            </button>
          </a>
          <a href="WelcomePage">
            <button className={styles.projectSelectCloseButtonClass}>
              Close
            </button>
          </a>
        </div>
      </div>
    </>
  );
}

export default ExperimentProjectSelect;
